import { render } from "./ProfileFeedbackCard.vue?vue&type=template&id=049ede8c"
import script from "./ProfileFeedbackCard.vue?vue&type=script&lang=js"
export * from "./ProfileFeedbackCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__